<template>
  <div class="title-line">
    <h4 class="title-between-line">{{ title }}</h4>
  </div>
</template>

<script>
export default {
  name: 'SectionTitleMobileLine',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 768px) {
  .title-between-line:before,
  .title-between-line:after {
    content: '';
    border-top: 2px solid #d20b12;
    margin: 0 20px 0 0;
    flex: 1 0 20px;
  }
  .title-between-line:after {
    margin: 0 0 0 20px;
}
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/SectionTitleMobileLine.vue